import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ContextMenuIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.contextMenuIcon}`}
        data-testid={testId}
        fill='none'
        height='42'
        viewBox='0 0 28 42'
        width='28'>
        <circle cx='14' cy='14' fill='currentColor' r='2' />

        <circle cx='14' cy='21' fill='currentColor' r='2' />

        <circle cx='14' cy='28' fill='currentColor' r='2' />
    </svg>
);

export default ContextMenuIcon;
